"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPatientDataReport = renderPatientDataReport;
const messages_1 = require("./messages");
function renderPatientDataReport(intl, { header, body }) {
    return `
		<!DOCTYPE html>
		<html lang="en">
		<head>
			<meta charset="UTF-8">
			<meta name="viewport" content="width=device-width, initial-scale=1.0">
			<title>Patient Dashboard Backup</title>
			<style>
				html {
					-webkit-print-color-adjust: exact;
					--primary-color: rgba(44, 154, 173, 0.85);
				}
				.section-list {
					display: flex;
					flex-direction: column;
					gap: 10px;
					font-family: Arial, sans-serif;
					font-size: 12px;
				}
				.section {
					border: 1px solid black;
					border-radius: 3px;
					overflow: hidden;
				}
				.section-header {
					padding: 5px 10px;
					font-weight: bold;
					color: white;
					background-color: var(--primary-color);
					text-align: center;
				}
				.section-content {
					display: flex;
					align-items: flex-start;
					flex-wrap: wrap;
					gap: 10px;
					background-color: #f0f0f0;
					padding: 10px;
				}
				.group {
					width: 100%;
					border-radius: 3px;
					border: 1px solid black;
					overflow: hidden;
					page-break-inside: avoid;
				}
				.group-header {
					padding: 5px 10px;
					font-weight: bold;
					color: white;
					background-color: var(--primary-color);
					text-align: center;
				}
				.group-content {
					display: flex;
					align-items: flex-start;
					flex-wrap: wrap;
					gap: 10px;
					padding: 10px;
				}
				.table-container {
					border: 1px solid black;
					border-radius: 3px;
					background-color: white;
					width: fit-content;
					overflow: hidden;
					page-break-inside: avoid;
				}
				.table-container-header {
					padding: 5px 10px;
					font-weight: bold;
					color: white;
					background-color: var(--primary-color);
					text-align: center;
				}
				.table-container-content {
					padding: 5px;
				}
				table {
					width: 100%;
					border: 1px solid #ccc;
					border-collapse: collapse;
					margin: 0;
				}
				th, td {
					border: 1px solid #ccc;
					padding: 5px 10px;
					vertical-align: top;
				}
				.box {
					border: 1px solid black;
					border-radius: 3px;
					background-color: white;
					width: fit-content;
					overflow: hidden;
					page-break-inside: avoid;
				}
				.box-header {
					padding: 5px 10px;
					font-weight: bold;
					color: white;
					background-color: var(--primary-color);
					text-align: center;
				}
				.short-box-content {
					padding: 5px 10px;
					text-align: center;
				}
				.long-box-content {
					padding: 5px 10px;
				}
				.attachment-list {
					display: flex;
					flex-direction: column;
					padding: 5px;
					color: var(--primary-color);
				}
				.section .attachment-list,
				.group .attachment-list,
				.table-container .attachment-list,
				.box .attachment-list {
					border-top: 1px solid #ccc;
				}
				.attachment-list td:first-child {
					width: 1%;
					white-space: nowrap;
				}
				.attachment-list button {
					border: none;
					background: transparent;
					padding: 0;
					margin: 0;
					font-size: 12px;
					color: var(--primary-color);
					text-decoration: underline;
					cursor: pointer;
				}
			</style>
		</head>
		<body>
			<div class="section-list">
				${renderHeader(intl, header)}
				${renderBody(intl, body)}
				${renderFooter(intl, body)}
			</div>
		</body>
		</html>
	`.replace(/\t/g, "");
}
function renderHeader(_intl, values) {
    return `
		<div class="table-container">
			<div class="table-container-content">
				<table>
					<tbody>
						${values.map(value => `<tr>${renderHeaderValue(value)}</tr>`).join("")}
					</tbody>
				</table>
			</div>
		</div>
	`;
}
function renderHeaderValue({ label, value }) {
    if (label && value) {
        return `
			<th>${label}:</th>
			<td>${renderValue(value)}</td>
		`;
    }
    if (label) {
        return `<td colspan="2">${label}</td>`;
    }
    if (value) {
        return `<td colspan="2">${renderValue(value)}</td>`;
    }
    return "";
}
function renderBody(intl, sections) {
    return sections.map(section => renderSection(intl, section)).join("");
}
function renderFooter(intl, sections) {
    const map = new Map();
    for (const { attachments } of sections) {
        if (attachments) {
            for (const attachment of attachments) {
                map.set(attachment.filename, attachment);
            }
        }
    }
    return renderAttachmentList(intl, Array.from(map.values()));
}
function renderSection(intl, { label, content }) {
    return `
		<div class="section">
			<div class="section-header">${label}</div>
			<div class="section-content">
				${content.map(item => renderSectionContentItem(intl, item)).join("")}
			</div>
		</div>
	`;
}
function renderSectionContentItem(intl, item) {
    switch (item.type) {
        case "group-list":
            return renderGroupList(intl, item);
        case "group":
            return renderGroup(intl, item);
        case "table":
            return renderTable(intl, item);
        case "table-group-list":
            return renderTableGroupList(intl, item);
        case "grouped-list":
            return renderGroupedList(intl, item);
        case "list":
            return renderList(intl, item);
        case "record":
            return renderRecord(intl, item);
    }
    return "";
}
function renderGroupList(intl, { groups }) {
    return groups.map(group => renderGroup(intl, group)).join("");
}
function renderGroup(intl, { label, content }) {
    return `
		<div class="group">
			${label ? `<div class="group-header">${label}</div>` : ""}
			<div class="group-content">
				${content.map(item => renderGroupContentItem(intl, item)).join("")}
			</div>
		</div>
	`;
}
function renderGroupContentItem(intl, item) {
    switch (item.type) {
        case "table":
            return renderTable(intl, item);
        case "table-group-list":
            return renderTableGroupList(intl, item);
        case "grouped-list":
            return renderGroupedList(intl, item);
        case "list":
            return renderList(intl, item);
        case "record":
            return renderRecord(intl, item);
    }
    return "";
}
function renderTable(intl, { label, columns, rows, attachments }) {
    return `
		<div class="table-container">
			${label ? `<div class="table-container-header">${label}</div>` : ""}
			<div class="table-container-content">
				<table>
					<thead>
						<tr>${columns.map(column => `<th>${column}</th>`).join("")}</tr>
					</thead>
					<tbody>
						${rows
        .map(row => `<tr>${row
        .map(value => `<td>${value}</td>`)
        .join("")}</tr>`)
        .join("")}
					</tbody>
				</table>
			</div>
			${renderAttachmentList(intl, attachments)}
		</div>
	`;
}
function renderTableGroupList(intl, { label, columns, groups, attachments }) {
    return `
		<div class="table-container">
			${label ? `<div class="table-container-header">${label}</div>` : ""}
			<div class="table-container-content">
				<table>
					<thead>
						<tr>${columns.map(column => `<th>${column}</th>`).join("")}</tr>
					</thead>
					<tbody>
						${groups
        .map(({ label, rows }) => `${label
        ? `<tr><th colspan="${rows.length === 0
            ? 0
            : rows[0].length}">${label}</th></tr>`
        : ""}${rows
        .map(row => `<tr>${row
        .map(value => `<td>${value}</td>`)
        .join("")}</tr>`)
        .join("")}`)
        .join("")}
					</tbody>
				</table>
			</div>
			${renderAttachmentList(intl, attachments)}
		</div>
	`;
}
function renderGroupedList(intl, { groups, attachments }) {
    let out = "";
    for (const { label, items } of groups) {
        out += `
			<div class="table-container">
				${label ? `<div class="table-container-header">${label}</div>` : ""}
				<div class="table-container-content">
					<table>
						<tbody>
							${items.map(renderListItem).join("")}
						</tbody>
					</table>
				</div>
				${renderAttachmentList(intl, attachments)}
			</div>
		`;
    }
    return out;
}
function renderList(intl, { label, items, attachments }) {
    return `
		<div class="table-container">
			${label ? `<div class="table-container-header">${label}</div>` : ""}
			<div class="table-container-content">
				<table>
					<tbody>
						${items.map(item => `<tr>${renderListItem(item)}</tr>`).join("")}
					</tbody>
				</table>
			</div>
			${renderAttachmentList(intl, attachments)}
		</div>
	`;
}
function renderListItem({ label, value }) {
    if (label && value) {
        return `
			<th>${label}:</th>
			<td>${renderValue(value)}</td>
		`;
    }
    if (label) {
        return `<td colspan="2">${label}</td>\n`;
    }
    if (value) {
        return `<td colspan="2">${renderValue(value)}</td>\n`;
    }
    return "";
}
function renderRecord(intl, { variant, label, value, attachments }) {
    const boxContentClassName = variant === "long" ? "long-box-content" : "short-box-content";
    if (label && value) {
        return `
			<div class="box">
				<div class="box-header">${label}</div>
				<div class="${boxContentClassName}">${renderValue(value)}</div>
				${renderAttachmentList(intl, attachments)}
			</div>
		`;
    }
    if (label) {
        return `
			<div class="box">
				<div class="${boxContentClassName}">${label}</div>
				${renderAttachmentList(intl, attachments)}
			</div>
		`;
    }
    if (value) {
        return `
			<div class="box">
				<div class="${boxContentClassName}">${renderValue(value)}</div>
				${renderAttachmentList(intl, attachments)}
			</div>
		`;
    }
    return "";
}
function renderValue(value) {
    return value.replace(/\n/g, "<br/>");
}
function renderAttachmentList({ formatMessage }, attachments) {
    if (!attachments || attachments.length === 0) {
        return "";
    }
    return `
		<div class="attachment-list">
			<table>
				<tbody>
					${attachments
        .map(a => `
							<tr>
								<td>${formatDateTime(a.timestamp)}</td>
								<td>
									${a.filename}&nbsp;-&nbsp;
									<button type="button" onClick="navigator.clipboard.writeText('${a.filename}')">
										${formatMessage(messages_1.genericMessages.copy)}
									</button>
								</td>
							</tr>
						`)
        .join("")}
				</tbody>
			</table>
		</div>
	`;
}
function formatDateTime(date) {
    return new Intl.DateTimeFormat("hu", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    }).format(new Date(date));
}
